import { render, staticRenderFns } from "./CreatePlusCategoryTiles.vue?vue&type=template&id=38b3c0a6&scoped=true&"
import script from "./CreatePlusCategoryTiles.vue?vue&type=script&lang=js&"
export * from "./CreatePlusCategoryTiles.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlusCategoryTiles.vue?vue&type=style&index=0&id=38b3c0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3c0a6",
  null
  
)

export default component.exports